import { calculateDigit, isRepeatedSequence } from './taxIdChecksum';

export const CPF_LENGTH = 11;

const CPF_WEIGHTS_DV1 = [10, 9, 8, 7, 6, 5, 4, 3, 2];
const CPF_WEIGHTS_DV2 = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];

export function sanitizeCpf(value) {
  return String(value).replace(/\D/g, '');
}

export function validateCpf(value) {
  if (!value) {
    return false;
  }

  const digits = sanitizeCpf(value).split('').map(Number);

  if (digits.length !== CPF_LENGTH || isRepeatedSequence(digits.join(''))) {
    return false;
  }

  const digit1 = calculateDigit(digits.slice(0, 9), CPF_WEIGHTS_DV1);
  const digit2 = calculateDigit(digits.slice(0, 10), CPF_WEIGHTS_DV2);

  return digit1 === digits[9] && digit2 === digits[10];
}

export function formatCpfDisplay(value) {
  const digits = sanitizeCpf(value).slice(0, CPF_LENGTH);
  const parts = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9), digits.slice(9, 11)];

  let formatted = parts[0];
  if (parts[1]) formatted += `.${parts[1]}`;
  if (parts[2]) formatted += `.${parts[2]}`;
  if (parts[3]) formatted += `-${parts[3]}`;

  return formatted;
}
